/**
 * `schema`, unchanged, on the condition that what it accepts is exactly
 * `Input`. `satisfies ZodType<Input, Input>` only checks that the schema's
 * types are assignable to `Input`, so a schema stricter than the declared type
 * — a dropped `.optional()`, an extra required field — still compiles and
 * rejects real values at runtime. This pins both directions at the
 * declaration.
 *
 * Two calls because TypeScript cannot take one type argument explicitly and
 * infer the other.
 */
export function acceptsExactly() {
    return (schema) => schema;
}
//# sourceMappingURL=acceptsExactly.js.map